mutation EndEvent($eventId: ID!) {
  event: StreamToolsEndEvent(eventId: $eventId) {
    eventId
    status
    endedAt
  }
}
